import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import * as React from 'react';

type Props = {
  label: string;
  leadingIcon?: FontAwesomeIconProps['icon'];
  onDismiss?: () => void;
  onClick?: () => void;
  active?: boolean;
  className?: string;
};

// Future PR: merge this into ScaleUI Chip
export const LargeChip = ({ label, leadingIcon, onDismiss, onClick, active, className }: Props) => {
  const handleDismissClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDismiss?.();
  };

  return (
    <span
      className={cn(
        'scaleui inline-flex items-center rounded bg-neutral-200 text-sm font-medium text-neutral-700 transition-colors w-fit px-3 py-1.5',
        { 'text-primary-900 bg-primary-100': active },
        className,
      )}
      onClick={onClick}
    >
      {leadingIcon && (
        <div className="mr-1">
          <FontAwesomeIcon icon={leadingIcon} />
        </div>
      )}
      {label}
      {onDismiss && (
        <button
          type="button"
          className={cn(
            'ml-0.5 -mr-1 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded text-neutral-400 hover:bg-neutral-200 hover:text-neutral-500 focus:bg-neutral-500 focus:text-neutral-0 focus:outline-none',
            {
              'text-primary-900 bg-primary-100 hover:bg-primary-200 hover:text-primary-500 focus:bg-primary-500':
                active,
            },
          )}
          onClick={handleDismissClick}
        >
          <span className="sr-only">{label}</span>
          <svg className="w-2 h-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
            <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7" />
          </svg>
        </button>
      )}
    </span>
  );
};
